import './TextareaWithCounter.css'

const DEFAULT_MAX_LENGTH = 500

/**
 * Textarea con límite de caracteres y contador (ej. 16/500).
 * Evita que el área crezca indefinidamente (max-height) y muestra el contador abajo a la derecha.
 */
function TextareaWithCounter({
  value = '',
  onChange,
  maxLength = DEFAULT_MAX_LENGTH,
  className = '',
  showCounter = true,
  ...rest
}) {
  const length = (value || '').length

  return (
    <div className="textarea-with-counter-wrapper">
      <textarea
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        className={`textarea-with-counter ${className}`.trim()}
        {...rest}
      />
      {showCounter && (
        <span className="textarea-char-counter" aria-live="polite">
          {length}/{maxLength}
        </span>
      )}
    </div>
  )
}

export default TextareaWithCounter
export { DEFAULT_MAX_LENGTH }
